export const PRIMARY = 'primary';
export const TRANSPARENT_ON_BACKGROUND = 'transparent-on-background';
export const TRANSPARENT_ON_PRIMARY = 'transparent-on-primary';